export default __webpack_public_path__ + "static/media/feature_freespinsrounds.a8c97b8b.jpg";